'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var loadMfsRoot = require('./with-mfs-root');

var toPathComponents = require('./to-path-components');

var exporter = require('ipfs-unixfs-exporter');

var errCode = require('err-code');

var IPFS_PREFIX = 'ipfs';

var toMfsPath = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, path) {
    var outputArray, paths, root;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            outputArray = Array.isArray(path);
            paths = Array.isArray(path) ? path : [path];
            _context2.next = 4;
            return loadMfsRoot(context);

          case 4:
            root = _context2.sent;
            paths = paths.map(function (path) {
              path = (path || '').trim();
              path = path.replace(/(\/\/+)/g, '/');

              if (path.endsWith('/') && path.length > 1) {
                path = path.substring(0, path.length - 1);
              }

              if (!path) {
                throw errCode(new Error('paths must not be empty'), 'ERR_NO_PATH');
              }

              if (path.substring(0, 1) !== '/') {
                throw errCode(new Error('paths must start with a leading slash'), 'ERR_INVALID_PATH');
              }

              if (path.substring(path.length - 1) === '/') {
                path = path.substring(0, path.length - 1);
              }

              var pathComponents = toPathComponents(path);

              if (pathComponents[0] === IPFS_PREFIX) {
                // e.g. /ipfs/QMfoo or /ipfs/Qmfoo/sub/path
                var _mfsDirectory;

                if (pathComponents.length === 2) {
                  _mfsDirectory = "/".concat(pathComponents.join('/'));
                } else {
                  _mfsDirectory = "/".concat(pathComponents.slice(0, pathComponents.length - 1).join('/'));
                }

                return {
                  type: 'ipfs',
                  depth: pathComponents.length - 2,
                  mfsPath: "/".concat(pathComponents.join('/')),
                  mfsDirectory: _mfsDirectory,
                  parts: pathComponents,
                  path: "/".concat(pathComponents.join('/')),
                  name: pathComponents[pathComponents.length - 1]
                };
              }

              var mfsPath = "/".concat(IPFS_PREFIX, "/").concat(root).concat(pathComponents.length ? '/' + pathComponents.join('/') : '');
              var mfsDirectory = "/".concat(IPFS_PREFIX, "/").concat(root, "/").concat(pathComponents.slice(0, pathComponents.length - 1).join('/'));
              return {
                type: 'mfs',
                depth: pathComponents.length,
                mfsDirectory: mfsDirectory,
                mfsPath: mfsPath,
                parts: pathComponents,
                path: "/".concat(pathComponents.join('/')),
                name: pathComponents[pathComponents.length - 1]
              };
            });
            _context2.next = 8;
            return Promise.all(paths.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
                var cidPath, res;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        cidPath = path.type === 'mfs' ? path.mfsPath : path.path;
                        _context.prev = 1;
                        _context.next = 4;
                        return exporter(cidPath, context.ipld);

                      case 4:
                        res = _context.sent;
                        path.cid = res.cid;
                        path.mfsPath = "/ipfs/".concat(res.path);
                        path.unixfs = res.unixfs;
                        path.content = res.content;
                        _context.next = 15;
                        break;

                      case 11:
                        _context.prev = 11;
                        _context.t0 = _context["catch"](1);

                        if (!(_context.t0.code !== 'ERR_NOT_FOUND')) {
                          _context.next = 15;
                          break;
                        }

                        throw _context.t0;

                      case 15:
                        path.exists = Boolean(path.cid);

                      case 16:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[1, 11]]);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 8:
            if (!outputArray) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", paths);

          case 10:
            return _context2.abrupt("return", paths[0]);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function toMfsPath(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = toMfsPath;